import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getCorrectPercentages } from '../../../../../utils/MasterObjectiveMapping';

const defaultProps = {
  objective: {},
  included: [],
  maxXAxis: null,
};

const ObjectiveLineChart = (props) => {
  const {
    objective,
    included,
    maxXAxis,
  } = { ...defaultProps, ...(props || {}) };
  const { attributes } = objective;
  const plotColor = objective.attributes.masteredStatus === 'criteria-met' ? '#5DB572' : '#000000';
  const correctPercentages = getCorrectPercentages(objective, included, maxXAxis);
  const maxX = maxXAxis || correctPercentages.length < 10 ? 10 : correctPercentages.length;

  return (
    <HighchartsReact
      highcharts={Highcharts}
      containerProps={{ style: { height: '100%', width: '100%' } }}
      options={{
        title: {
          text: '',
        },
        legend: { enabled: false },
        credits: {
          enabled: false,
        },
        xAxis: {
          visible: false,
          max: maxX,
          min: 0,
        },
        yAxis: {
          max: 100,
          min: 0,
          plotLines: [{
            color: '#BFBEBF',
            width: 2,
            value: attributes.percentCorrect,
            dashStyle: 'dash',
          }],
          title: '',
        },
        plotOptions: {
          series: {
            color: plotColor,
            tooltip: false,
          },
        },
        tooltip: {
          // eslint-disable-next-line func-names, object-shorthand
          formatter: function () {
            // eslint-disable-next-line react/no-this-in-sfc
            const { options: { lessonName, playDate, y } } = this.point;
            const lesson = lessonName ? `Activity : <b>${lessonName}</b><br/>` : '';
            const playDateString = playDate ? `Played On : <b>${playDate}</b><br/>` : '';
            const scoreString = y ? `Score : <b> ${y} </b>` : '';

            return `${lesson}${playDateString}${scoreString}`;
          },
        },
        series: [{
          data: correctPercentages,
        }],
      }}
    />
  );
};

export default ObjectiveLineChart;
